dmx.Component('select-multiple', {

    extends: 'select',

    initialData: {
        value: []
    },

    attributes: {
        value: {
            type: Array,
            default: null
        }
    },

    methods: {
        setSelectedIndex: function(index) {
            this.$node.selectedIndex = index;
            this.updateData();
        }
    },

    update: function(props) {
        if (!dmx.equal(props.options, this.props.options)) {
            this.renderOptions();
            this.updateValue = true;
        }

        if (!dmx.equal(props.value, this.props.value)) {
            this.updateValue = true;
        }

        if (props.disabled != this.props.disabled) {
            this.$node.disabled = this.props.disabled;
        }

        this.updateData();
    },

    updateData: function(event) {
        var value = Array.prototype.slice.call(this.$node.options).filter(function(option) {
            return option.selected;
        }).map(function(option) {
            return option.value;
        });

        if (!dmx.equal(this.data.value, value)) {
            dmx.nextTick(function() {
                this.dispatchEvent('updated');
                if (event) this.dispatchEvent('changed');
            }, this);
        }

        this.set('value', value);
        this.set('disabled', this.$node.disabled);
        this.set('invalid', !this.$node.validity.valid);
        this.set('focused', this.$node === document.activeElement);
        this.set('validationMessage', this.$node.validationMessage);
        
        var selectedIndex = this.$node.selectedIndex;
        this.set('selectedIndex', selectedIndex);
        this.set('selectedValue', this.$node.options[selectedIndex] && this.$node.options[selectedIndex].value || '');
        this.set('selectedText', this.$node.options[selectedIndex] && this.$node.options[selectedIndex].text || '');
    },

    setValue: function(value, isDefault) {
        if (!Array.isArray(value)) value = [value];
        value = value.map(function(v) { return v.toString(); });
        dmx.array(this.$node.options).forEach(function(option) {
            option.selected = value.indexOf(option.value) > -1;
            if (isDefault) option.defaultSelected = option.selected;
        });
    }

});
